import { ChecklistItem } from './../builders/checklist_item_builder';
import { Strategy, IStrategy } from 'utility-ts-strategy';

export type ChecklistFilter = (values: ChecklistItem[]) => ChecklistItem[];

export interface IChecklistFilterAlgorithm {
  filterChecklist: ChecklistFilter;
  viewText: string;
  color: string;
  icon: string;
  heading: string;
}

export interface IChecklistFilterStrategy extends IStrategy<IChecklistFilterAlgorithm> {
  normal: IChecklistFilterAlgorithm;
  completed: IChecklistFilterAlgorithm;
}

angular.module('capability-ng-checklist').constant(
  'ngChecklistFilterStrategy',
  new Strategy<IChecklistFilterAlgorithm>({
    normal: {
      filterChecklist: (collection) =>
        _.filter(collection, (item) => item.status === 'normal' || item.status === 'transitionToComplete'),
      viewText: 'All Items - Checklist',
      color: 'orange',
      icon: 'circle_filled',
      heading: 'Remaining Checklist items'
    },
    completed: {
      filterChecklist: (collection) =>
        _.filter(collection, (item) => item.status === 'complete' || item.status === 'transitionToNormal'),
      icon: 'check',
      color: 'green',
      viewText: 'Completed',
      heading: 'Completed Checklist items'
    }
  })
);



// WEBPACK FOOTER //
// ./app/lib/checklist/strategies/checklist_filter_strategy.ts